import { graphql } from "@opensea/graphql"

export const RarityBadgeFragment = graphql(`
  fragment RarityBadge on Item {
    rarity {
      category
      rank
      totalSupply
    }
  }
`)
